import React, { useState } from "react";
import "../../index.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import carousel1 from "../../assets/img/carousel-1.webp";
import carousel2 from "../../assets/img/carousel-2.webp";
import carousel3 from "../../assets/img/carousel-3.webp";
import about from "../../assets/img/about.webp"
import Courses from "./Courses";
import Registration from "./Registration";
import TestimonialCarousel from "./TestimonialCarousel";
import PromoBar from "./PromoBar";
import CommunityBanner from "./CommunityBanner";

const Home = () => {
 // const [showModal, setShowModal] = useState(false);
  return (
    <>
      {/* Carousel Start */}
      <div className="container-fluid p-0 pb-5 mb-5">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop
          className="carousel-inner"
        >
          <SwiperSlide>
            <img className="position-relative w-100" src={carousel1} alt="Slide 1" />
            <div className="carousel-caption d-flex align-items-center justify-content-center">
              <div className="p-5" style={{ width: "100%", maxWidth: "900px" }}>
                <h5 className="text-white text-uppercase mb-md-3">Cursos totalmente Online</h5>
                <h1 className="display-3 text-white mb-md-4">La mejor educación desde tu hogar</h1>
                <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero ver los cursos</Link>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img className="position-relative w-100" src={carousel2} alt="Slide 2" />
            <div className="carousel-caption d-flex align-items-center justify-content-center">
              <div className="p-5" style={{ width: "100%", maxWidth: "900px" }}>
                <h5 className="text-white text-uppercase mb-md-3">Cursos totalmente Online</h5>
                <h1 className="display-3 text-white mb-md-4">La mejor plataforma de aprendizaje en línea</h1>
                <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero ver los cursos</Link>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img className="position-relative w-100" src={carousel3} alt="Slide 3" />
            <div className="carousel-caption d-flex align-items-center justify-content-center">
              <div className="p-5" style={{ width: "100%", maxWidth: "900px" }}>
                <h5 className="text-white text-uppercase mb-md-3">Cursos totalmente Online</h5>
                <h1 className="display-3 text-white mb-md-4">Aprende más desde tu casa</h1>
                <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero ver los cursos</Link>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      {/* Carousel End */}

      {/* Hook de la academia */}
      <div>
        <PromoBar />
      </div>


      {/* Acerca de Start */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <img className="img-fluid rounded mb-4 mb-lg-0" src={about} alt="About Us" />
            </div>
            <div className="col-lg-7">
              <div className="text-title-about mb-4">
                <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>
                  Acerca de
                </h5>
                <h1>Una forma innovadora de aprender</h1>
              </div>
              <p style={{ textAlign: "justify" }}>
                La educación online ha transformado el panorama del aprendizaje, ofreciendo una forma innovadora de aprender
                que rompe las barreras geográficas y de tiempo. Este enfoque ha revolucionado la educación al permitir que
                estudiantes de todas partes del mundo accedan a una amplia variedad de recursos, cursos y expertos con solo
                una conexión a internet.
              </p>
              <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">Quiero ver los cursos</Link>
            </div>
          </div>
        </div>
      </div>
      {/* Acerca de End */}
      <Courses />
      <Registration />
      <TestimonialCarousel />
      <hr></hr>
      <CommunityBanner />
    </>
  );
};

export default Home;
